import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";
import React from "react";

const ReportsUsersList = lazyLoader(
  () =>
    import(
      "Containers/Reports/ReportsInnerPages/ReportsUserList/ReportsUserList/ReportsUserList"
    )
);
export const ReportsUsersListPage = () => {
  return (
    <Layout>
      <ReportsUsersList />
    </Layout>
  );
};
